export default __webpack_public_path__ + "static/media/refer-compressed.53d2b27e.jpg";